/* --- Feature: Home Kachel-Filter + Packery-Reflow + Load more ---
   Filter: PLACES / PRODUCTS / PLAY + ✕-Reset.
   Beim Filtern: wenn Kacheln oben angeschnitten sind, smooth zurück bis
   zur natürlichen Filterposition. Auf Mobile bleibt das Ziel oben.
   Load more: zeigt zunächst eine Seite Kacheln, Rest per Button (Figma Final).
   Packery berechnet das neue Zielraster; der Filter blendet den bisherigen
   Inhalt aus und die finalen Reihen kontrolliert wieder ein. Load-more-Karten
   faden reihenweise am Zielort ein.
   Defensiv: läuft nur, wenn die Section existiert. */
(function () {
  var section = document.querySelector('[data-home-tiles]');
  if (!section) return;

  var buttons = section.querySelectorAll('[data-filter-value]');
  var resets = section.querySelectorAll('[data-filter-reset]');
  var subfilterGroups = section.querySelectorAll('[data-subfilters]');
  var subfilterButtons = section.querySelectorAll('[data-subfilter-value]');
  var subfilterResets = section.querySelectorAll('[data-subfilter-reset]');
  var tiles = Array.prototype.slice.call(section.querySelectorAll('.tile-card[data-filters]'));
  var loadMore = section.querySelector('[data-load-more]');
  var PAGE = 20; /* weitere Kacheln pro Klick auf „Load more“ */
  var INITIAL_PAGE = PAGE + 10; /* zehn zusätzliche Kacheln vor „Load more“ */
  var SMALL_REMAINDER = 3; /* keine letzte Seite mit nur 1–3 Kacheln */
  var shown = INITIAL_PAGE;
  var isShopPage = document.body && document.body.classList.contains('page-shop');
  var filterValue = section.getAttribute('data-initial-filter') || null;
  var subfilterValue = null;
  var filterGroup = section.querySelector('.home-tiles__filters');
  var filterBar = section.querySelector('.home-tiles__filter-bar');
  var grid = section.querySelector('.home-tiles__grid');
  var originalTileOrder = new Map();
  var packery = null;
  var gridVisibilityFrame = null;
  var packerySyncSequence = 0;
  var filterMotionTimers = [];
  var FILTER_FADE_DURATION = '0.16s';
  var LAYOUT_DURATION = '0.75s';
  var LAYOUT_STAGGER = '35ms';
  var FILTER_EXIT_MS = 240;
  var FILTER_ENTER_MS = 520;
  var FILTER_ROW_STAGGER_MS = 100;
  var FILTER_CUE_DELAY_MS = 2000;
  var FILTER_CUE_STAGGER_MS = 120;
  var PHONE_MEDIA_QUERY = '(max-width: 950px)';
  var filterCueStartTimer = null;
  var filterCueTimers = [];
  var filterWasClicked = false;
  var TILE_FORMATS = [
    { width: 217, ratio: 217 / 290, pct: 19.82 },
    { width: 290, ratio: 1, pct: 26.49 },
    { width: 388, ratio: 388 / 290, pct: 35.45 }
  ];

  tiles.forEach(function (tile, index) {
    originalTileOrder.set(tile, index);
  });

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function subfilterGroupFor(filter) {
    var match = null;
    Array.prototype.forEach.call(subfilterGroups, function (group) {
      if (group.getAttribute('data-subfilters') === filter) match = group;
    });
    return match;
  }

  function tileHasFilter(tile, filter) {
    var tileFilters = (tile.getAttribute('data-filters') || '').split(/\s+/).filter(Boolean);
    return tileFilters.indexOf(filter) !== -1;
  }

  function tileMatchesSubfilter(tile, filter, value) {
    if (!value || !tileHasFilter(tile, filter)) return false;

    if (filter === 'products') {
      var categories = (tile.getAttribute('data-product-categories') || '')
        .split(/\s+/)
        .map(slugify)
        .filter(Boolean);
      if (categories.length) return categories.indexOf(value) !== -1;
      var tags = (tile.getAttribute('data-product-tags') || '').split(',').map(slugify);
      return tags.indexOf(value) !== -1;
    }

    if (filter === 'play') {
      return slugify(tile.getAttribute('data-play-category')) === value;
    }

    return false;
  }

  function syncAvailableSubfilters() {
    subfilterButtons.forEach(function (btn) {
      var group = btn.closest('[data-subfilters]');
      var item = btn.closest('.home-tiles__subfilter-item');
      if (!group || !item) return;

      var filter = group.getAttribute('data-subfilters');
      var value = btn.getAttribute('data-subfilter-value');
      /* Alle Kacheln prüfen, auch jene hinter „Load more“. */
      var available = tiles.some(function (tile) {
        return tileMatchesSubfilter(tile, filter, value);
      });

      item.hidden = !available;
      btn.disabled = !available;
    });
  }

  function availableSubfilterGroupFor(filter) {
    var group = subfilterGroupFor(filter);
    if (!group) return null;
    var items = group.querySelectorAll('.home-tiles__subfilter-item');
    var hasAvailableItem = Array.prototype.some.call(items, function (item) {
      return !item.hidden;
    });
    return hasAvailableItem ? group : null;
  }

  function readInitialFilters() {
    if (!window.URLSearchParams) return;
    var params = new window.URLSearchParams(window.location.search);
    var requestedFilter = slugify(params.get('filter'));
    var requestedCategory = slugify(params.get('category'));
    var validFilters = ['places', 'products', 'play'];
    if (isShopPage && requestedFilter === 'all') filterValue = null;
    else if (validFilters.indexOf(requestedFilter) !== -1) filterValue = requestedFilter;
    var activeGroup = availableSubfilterGroupFor(filterValue);
    var validCategories = activeGroup
      ? Array.prototype.map.call(activeGroup.querySelectorAll('[data-subfilter-value]'), function (btn) {
        return btn.disabled ? null : btn.getAttribute('data-subfilter-value');
      }).filter(Boolean)
      : [];
    if (validCategories.indexOf(requestedCategory) !== -1) {
      subfilterValue = requestedCategory;
    }
  }

  function syncFooterQueryLink() {
    if (!window.URL || !window.URLSearchParams) return;

    var currentUrl = new window.URL(window.location.href);
    var footerLinks = document.querySelectorAll('.site-footer__link[href*="?"]');

    Array.prototype.forEach.call(footerLinks, function (link) {
      var linkUrl = new window.URL(link.href, currentUrl.origin);
      var isCurrent = linkUrl.pathname === currentUrl.pathname;

      linkUrl.searchParams.forEach(function (value, key) {
        if (currentUrl.searchParams.get(key) !== value) isCurrent = false;
      });

      link.classList.toggle('is-current', isCurrent);
      if (isCurrent) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  function syncUrlState() {
    if (!window.URL || !window.history || !window.history.replaceState) return;
    var url = new window.URL(window.location.href);
    if (isShopPage && filterValue === 'products') url.searchParams.delete('filter');
    else if (isShopPage && !filterValue) url.searchParams.set('filter', 'all');
    else if (filterValue) url.searchParams.set('filter', filterValue);
    else url.searchParams.delete('filter');
    if (availableSubfilterGroupFor(filterValue) && subfilterValue) {
      url.searchParams.set('category', subfilterValue);
    } else {
      url.searchParams.delete('category');
    }
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    syncFooterQueryLink();
  }

  function tileMatchesFilters(tile) {
    if (!filterValue && tile.getAttribute('data-show-on-landing') === 'false') return false;
    if (filterValue && !tileHasFilter(tile, filterValue)) return false;
    if (!subfilterValue) return true;
    return tileMatchesSubfilter(tile, filterValue, subfilterValue);
  }

  syncAvailableSubfilters();
  readInitialFilters();
  /* Nicht verfügbare Kategorien aus direkten/alten Links entfernen. */
  syncUrlState();

  function tileIsShown(tile) {
    return !tile.classList.contains('tile-card--hidden') &&
      !tile.classList.contains('tile-card--paged-out');
  }

  function updateGridVisibility() {
    if (!grid || !document.body) return;
    window.cancelAnimationFrame(gridVisibilityFrame);
    gridVisibilityFrame = window.requestAnimationFrame(function () {
      var filterBottom = filterGroup ? filterGroup.getBoundingClientRect().bottom : 0;

      Array.prototype.forEach.call(subfilterGroups, function (group) {
        if (!group.hidden) filterBottom = Math.max(filterBottom, group.getBoundingClientRect().bottom);
      });

      var lastTileBottom = tiles.reduce(function (bottom, tile) {
        if (!tileIsShown(tile)) return bottom;
        var rect = tile.getBoundingClientRect();
        return rect.width && rect.height ? Math.max(bottom, rect.bottom) : bottom;
      }, -Infinity);

      document.body.classList.toggle(
        'home-grid-past',
        lastTileBottom !== -Infinity && lastTileBottom <= filterBottom
      );
    });
  }

  function currentGutter() {
    return window.matchMedia(PHONE_MEDIA_QUERY).matches ? 10 : 14;
  }

  function compactMobileTileOrder(visibleTiles) {
    var remaining = visibleTiles.slice();
    var ordered = [];

    while (remaining.length) {
      var tile = remaining.shift();
      var isWide = tile.classList.contains('tile-card--w388');

      if (isWide) {
        ordered.push(tile);
        continue;
      }

      var partnerIndex = remaining.findIndex(function (candidate) {
        return !candidate.classList.contains('tile-card--w388');
      });

      if (partnerIndex === -1) {
        /* Die ungerade halbbreite Restkachel ans Ende setzen. Dort kann sie
           auf Phone gezielt das Vollbreitenformat übernehmen. */
        ordered = ordered.concat(remaining, tile);
        break;
      }

      var partner = remaining.splice(partnerIndex, 1)[0];
      ordered.push(tile, partner);

      /* Nur die eine Partnerkachel wird vorgezogen. Dazwischenliegende
         Vollbreiten-Kacheln behalten untereinander ihre Shopify-Reihenfolge. */
      if (partnerIndex > 0) {
        ordered = ordered.concat(remaining.splice(0, partnerIndex));
      }
    }

    return ordered;
  }

  function syncPackeryItemOrder() {
    if (!packery) return;

    tiles.forEach(function (tile) {
      tile.classList.remove('tile-card--mobile-wide');
    });

    var originalItems = packery.items.slice().sort(function (a, b) {
      return originalTileOrder.get(a.element) - originalTileOrder.get(b.element);
    });

    var visibleElements = originalItems.map(function (item) {
      return item.element;
    }).filter(tileIsShown);

    if (window.matchMedia(PHONE_MEDIA_QUERY).matches) {
      visibleElements = compactMobileTileOrder(visibleElements);
      var halfWidthCount = visibleElements.filter(function (tile) {
        return !tile.classList.contains('tile-card--w388');
      }).length;
      var lastVisibleTile = visibleElements[visibleElements.length - 1];

      if (lastVisibleTile && halfWidthCount % 2 === 1) {
        lastVisibleTile.classList.add('tile-card--mobile-wide');
      }
    }

    var orderedVisible = visibleElements;

    var visibleSet = new Set(orderedVisible);
    var hiddenItems = originalItems.filter(function (item) {
      return !visibleSet.has(item.element);
    });
    var itemsByElement = new Map(originalItems.map(function (item) {
      return [item.element, item];
    }));

    packery.items = orderedVisible.map(function (tile) {
      return itemsByElement.get(tile);
    }).concat(hiddenItems);
  }

  function closestTileFormat(sourceRatio) {
    return TILE_FORMATS.reduce(function (closest, format) {
      return Math.abs(format.ratio - sourceRatio) < Math.abs(closest.ratio - sourceRatio)
        ? format
        : closest;
    });
  }

  function applyTileFormat(tile, sourceRatio) {
    if (!sourceRatio || !isFinite(sourceRatio) || sourceRatio <= 0) return false;
    var format = closestTileFormat(sourceRatio);
    var currentFormat = Number(tile.getAttribute('data-tile-format'));
    var media = tile.querySelector('.tile-card__media');

    TILE_FORMATS.forEach(function (candidate) {
      tile.classList.remove('tile-card--w' + candidate.width);
    });
    tile.classList.add('tile-card--w' + format.width);
    tile.setAttribute('data-tile-format', String(format.width));
    tile.style.flexBasis = 'calc(' + format.pct + '% - 1px)';
    tile.style.width = 'calc(' + format.pct + '% - 1px)';
    if (media) media.style.aspectRatio = format.width + ' / 290';

    return currentFormat !== format.width;
  }

  var mediaLayoutFrame = null;
  function queueMediaLayout() {
    if (!packery) return;
    window.cancelAnimationFrame(mediaLayoutFrame);
    mediaLayoutFrame = window.requestAnimationFrame(function () {
      syncPackery(true);
    });
  }

  function applyFormatFromMedia(tile) {
    var media = tile.querySelector('video, img');
    var serverRatio = Number(tile.getAttribute('data-media-aspect-ratio'));

    if (serverRatio > 0) applyTileFormat(tile, serverRatio);
    if (!media) return;

    function updateFromIntrinsicSize() {
      var width = media.videoWidth || media.naturalWidth || 0;
      var height = media.videoHeight || media.naturalHeight || 0;
      if (width > 0 && height > 0 && applyTileFormat(tile, width / height)) {
        queueMediaLayout();
      }
    }

    if (media.tagName === 'VIDEO') {
      media.addEventListener('loadedmetadata', updateFromIntrinsicSize, { once: true });
      if (media.readyState >= 1) updateFromIntrinsicSize();
    } else {
      media.addEventListener('load', updateFromIntrinsicSize, { once: true });
      if (media.complete) updateFromIntrinsicSize();
    }
  }

  function enableImageFallback(tile) {
    var image = tile.querySelector('.tile-card__media > img');
    if (!image) return;

    function useFallback() {
      if (image.getAttribute('data-fallback-attempted') === 'true') return;

      var fallbackSrc = image.getAttribute('src');
      if (!fallbackSrc) return;

      image.setAttribute('data-fallback-attempted', 'true');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = fallbackSrc;
    }

    image.addEventListener('error', useFallback);
    if (image.complete && image.naturalWidth === 0) useFallback();
  }

  function groupByRenderedRow(tileEls) {
    var rows = [];
    tileEls.map(function (tile) {
      var rect = tile.getBoundingClientRect();
      return { tile: tile, top: rect.top, left: rect.left };
    }).sort(function (a, b) {
      return a.top - b.top || a.left - b.left;
    }).forEach(function (entry) {
      var row = rows[rows.length - 1];
      if (!row || Math.abs(entry.top - row.top) > 4) {
        row = { top: entry.top, items: [] };
        rows.push(row);
      }
      row.items.push(entry.tile);
    });
    return rows;
  }

  function fadeRowsIn(tileEls) {
    if (!tileEls.length) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rows = groupByRenderedRow(tileEls);
    var ROW_STAGGER_MS = 120;
    var FADE_MS = 550;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

    if (reduceMotion) {
      tileEls.forEach(function (tile) {
        tile.style.transition = '';
        tile.style.transitionDelay = '';
        tile.style.opacity = '';
      });
      return;
    }

    void grid.offsetHeight;
    window.requestAnimationFrame(function () {
      rows.forEach(function (row, rowIndex) {
        row.items.forEach(function (tile) {
          tile.style.transition = 'opacity ' + FADE_MS + 'ms ' + EASE;
          tile.style.transitionDelay = rowIndex * ROW_STAGGER_MS + 'ms';
          tile.style.opacity = '1';
        });
      });
    });

    window.setTimeout(function () {
      tileEls.forEach(function (tile) {
        var item = packery && packery.getItem(tile);
        tile.style.transition = '';
        tile.style.transitionDelay = '';
        if (!item || !item.isHidden) tile.style.opacity = '';
      });
    }, (rows.length - 1) * ROW_STAGGER_MS + FADE_MS + 100);
  }

  function scheduleFilterMotion(callback, delay) {
    var timer = window.setTimeout(function () {
      filterMotionTimers = filterMotionTimers.filter(function (candidate) {
        return candidate !== timer;
      });
      callback();
    }, delay);
    filterMotionTimers.push(timer);
  }

  function resetFilterMotion() {
    filterMotionTimers.forEach(window.clearTimeout);
    filterMotionTimers = [];
    tiles.forEach(function (tile) {
      tile.classList.remove('is-filter-exiting', 'is-filter-entering');
      tile.style.removeProperty('--filter-enter-delay');
    });
  }

  function syncPackery(isInstant, fadeOnlyTiles, onFilterSettled) {
    if (!packery) {
      if (onFilterSettled) onFilterSettled();
      return;
    }
    resetFilterMotion();
    syncPackeryItemOrder();
    var syncSequence = ++packerySyncSequence;
    packery.options.gutter = currentGutter();
    packery.options.rowHeight = 0;
    var toHide = [];
    var toReveal = [];
    var fadeOnly = fadeOnlyTiles || [];

    tiles.forEach(function (tile) {
      var item = packery.getItem(tile);
      if (!item) return;

      if (tileIsShown(tile)) {
        packery.unignore(tile);
        if (item.isHidden) toReveal.push(tile);
      } else {
        packery.ignore(tile);
        if (!item.isHidden) toHide.push(tile);
      }
    });

    /* Filterwechsel laufen als eine kontrollierte Sequenz: den bisherigen
       Inhalt gemeinsam ausblenden, das neue Packery-Raster unsichtbar sofort
       setzen und die finalen Reihen anschließend gestaffelt einblenden. */
    if (!isInstant && !fadeOnly.length) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var currentVisible = tiles.filter(function (tile) {
        var item = packery.getItem(tile);
        return item && !item.isHidden;
      });

      function swapFilteredTiles() {
        if (syncSequence !== packerySyncSequence) return;

        var targetVisible = tiles.filter(tileIsShown);
        if (!reduceMotion) {
          targetVisible.forEach(function (tile) {
            tile.classList.add('is-filter-entering');
          });
        }
        currentVisible.forEach(function (tile) {
          tile.classList.remove('is-filter-exiting');
        });

        packery.options.transitionDuration = 0;
        packery.options.stagger = 0;
        if (toHide.length) packery.hideItemElements(toHide);
        if (toReveal.length) packery.revealItemElements(toReveal);
        packery.layout();
        packery.options.transitionDuration = LAYOUT_DURATION;
        packery.options.stagger = LAYOUT_STAGGER;

        if (reduceMotion) {
          resetFilterMotion();
          if (onFilterSettled) onFilterSettled();
          return;
        }

        var rows = groupByRenderedRow(targetVisible);
        rows.forEach(function (row, rowIndex) {
          row.items.forEach(function (tile) {
            tile.style.setProperty('--filter-enter-delay', rowIndex * FILTER_ROW_STAGGER_MS + 'ms');
          });
        });

        /* Eintrittszustand sicher painten, bevor die Klassen entfernt werden. */
        void grid.offsetHeight;
        window.requestAnimationFrame(function () {
          if (syncSequence !== packerySyncSequence) return;
          targetVisible.forEach(function (tile) {
            tile.classList.remove('is-filter-entering');
          });
        });

        var lastDelay = Math.max(0, rows.length - 1) * FILTER_ROW_STAGGER_MS;
        scheduleFilterMotion(function () {
          if (syncSequence !== packerySyncSequence) return;
          targetVisible.forEach(function (tile) {
            tile.style.removeProperty('--filter-enter-delay');
          });
          if (onFilterSettled) onFilterSettled();
        }, lastDelay + FILTER_ENTER_MS + 50);
      }

      if (reduceMotion || !currentVisible.length) {
        swapFilteredTiles();
        return;
      }

      currentVisible.forEach(function (tile) {
        tile.classList.add('is-filter-exiting');
      });
      scheduleFilterMotion(swapFilteredTiles, FILTER_EXIT_MS);
      return;
    }

    var fadeReveal = toReveal.filter(function (tile) {
      return fadeOnly.indexOf(tile) !== -1;
    });
    var regularReveal = toReveal.filter(function (tile) {
      return fadeOnly.indexOf(tile) === -1;
    });

    /* Load-more-Karten unsichtbar direkt an ihre Packery-Zielposition
       setzen. Der anschließende Reihen-Stagger animiert nur opacity. */
    fadeReveal.forEach(function (tile) {
      var item = packery.getItem(tile);
      if (item) item.isLayoutInstant = true;
    });

    function layoutVisibleTiles() {
      if (syncSequence !== packerySyncSequence) return;

      packery.options.transitionDuration = isInstant ? 0 : LAYOUT_DURATION;
      packery.options.stagger = isInstant ? 0 : LAYOUT_STAGGER;
      if (regularReveal.length) packery.revealItemElements(regularReveal);

      if (fadeReveal.length) {
        var transitionDuration = packery.options.transitionDuration;
        packery.options.transitionDuration = 0;
        packery.revealItemElements(fadeReveal);
        packery.options.transitionDuration = transitionDuration;
        fadeReveal.forEach(function (tile) {
          tile.style.transition = 'none';
          tile.style.opacity = '0';
        });
      }

      packery.layout();
      packery.options.transitionDuration = LAYOUT_DURATION;
      packery.options.stagger = LAYOUT_STAGGER;

      fadeReveal.forEach(function (tile) {
        var item = packery.getItem(tile);
        if (item) delete item.isLayoutInstant;
      });
      fadeRowsIn(fadeReveal);
    }

    if (!isInstant && toHide.length) {
      /* Filterwechsel klar lesbar machen: erst die aussortierten Kacheln
         kurz ausblenden, danach die sichtbaren Kacheln an ihre neuen
         Packery-Positionen fahren. So dominiert nicht länger nur der Fade. */
      packery.options.transitionDuration = FILTER_FADE_DURATION;
      packery.options.stagger = 0;
      packery.once('hideComplete', layoutVisibleTiles);
      packery.hideItemElements(toHide);
      return;
    }

    if (isInstant) {
      packery.options.transitionDuration = 0;
      packery.options.stagger = 0;
    }
    if (toHide.length) packery.hideItemElements(toHide);
    layoutVisibleTiles();
  }

  function announcePackeryReady() {
    if (!grid || grid.getAttribute('data-packery-ready') === '1') return;
    grid.setAttribute('data-packery-ready', '1');
    section.classList.remove('home-tiles--filter-pending');
    document.dispatchEvent(new CustomEvent('home:packery-ready'));
  }

  function useOrderedRows(instance) {
    /* Packery füllt standardmäßig jede passende Restfläche. Für dieses
       kuratierte Zeilenraster soll die DOM-Reihenfolge jedoch erhalten
       bleiben: links→rechts, danach Umbruch wieder ganz links. Packery
       übernimmt weiterhin Hide/Reveal und alle Positions-Transitions. */
    var resetLayout = instance._resetLayout;
    instance._resetLayout = function () {
      resetLayout.call(this);
      this.orderedRowX = 0;
      this.orderedRowY = 0;
      this.orderedRowHeight = 0;
      orderAboutItemForFirstRow(this);
    };

    instance._getItemLayoutPosition = function (item) {
      this._setRectSize(item.element, item.rect);
      var rect = item.rect;
      var hasItemsInRow = this.orderedRowX > 0;
      var doesNotFit = this.orderedRowX + rect.width > this.packer.width + 0.5;

      if (hasItemsInRow && doesNotFit) {
        this.orderedRowX = 0;
        this.orderedRowY += this.orderedRowHeight;
        this.orderedRowHeight = 0;
      }

      rect.x = this.orderedRowX;
      rect.y = this.orderedRowY;
      this.orderedRowX += rect.width;
      this.orderedRowHeight = Math.max(this.orderedRowHeight, rect.height);
      this._setMaxXY(rect);
      return { x: rect.x, y: rect.y };
    };
  }

  function orderAboutItemForFirstRow(instance) {
    var currentItems = instance.items.slice();
    var visibleItems = currentItems.filter(function (item) {
      return tileIsShown(item.element);
    });
    var aboutItem = visibleItems.find(function (item) {
      return item.element.getAttribute('data-tile-role') === 'about';
    });
    if (!aboutItem || visibleItems.length < 2) return;

    /* Dieser Zeitpunkt liegt innerhalb von Packerys _resetLayout: Breite,
       Gutter und die gerundeten Kartenmaße entsprechen daher exakt der
       folgenden Platzierung – auch nach einem Desktop-Resize. */
    var otherItems = visibleItems.filter(function (item) {
      return item !== aboutItem;
    });
    instance._setRectSize(aboutItem.element, aboutItem.rect);
    var usedWidth = 0;
    var firstRow = [];

    for (var index = 0; index < otherItems.length; index += 1) {
      var item = otherItems[index];
      instance._setRectSize(item.element, item.rect);
      if (usedWidth + item.rect.width + aboutItem.rect.width > instance.packer.width + 0.5) break;
      firstRow.push(item);
      usedWidth += item.rect.width;
    }

    if (!firstRow.length) return;
    var firstRowSet = new Set(firstRow);
    var laterVisibleItems = otherItems.filter(function (item) {
      return !firstRowSet.has(item);
    });
    var hiddenItems = currentItems.filter(function (item) {
      return !tileIsShown(item.element);
    });
    instance.items = firstRow.concat([aboutItem], laterVisibleItems, hiddenItems);
  }

  function initPackery() {
    if (!grid || typeof window.Packery !== 'function') {
      announcePackeryReady();
      return;
    }
    packery = new window.Packery(grid, {
      itemSelector: '.tile-card',
      gutter: currentGutter(),
      rowHeight: 0,
      initLayout: false,
      resize: false,
      shiftPercentResize: true,
      transitionDuration: LAYOUT_DURATION,
      stagger: LAYOUT_STAGGER,
      hiddenStyle: { opacity: 0 },
      visibleStyle: { opacity: 1 }
    });
    useOrderedRows(packery);
    grid.classList.add('packery-ready');
    packery.once('layoutComplete', announcePackeryReady);
    packery.on('layoutComplete', updateGridVisibility);
    syncPackery(true);

    var resizeFrame = null;
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () {
        syncPackery(true);
      });
    });
  }

  function visibleTiles() {
    return tiles.filter(tileMatchesFilters);
  }

  function prepareLoadMore(shouldShow, waitForFilter) {
    if (!loadMore) return;

    if (!shouldShow) {
      loadMore.hidden = true;
      loadMore.disabled = false;
      loadMore.classList.remove('is-filter-pending');
      return;
    }

    loadMore.hidden = false;
    loadMore.disabled = !!waitForFilter;
    loadMore.classList.toggle('is-filter-pending', !!waitForFilter);
  }

  function revealLoadMoreAfterFilter() {
    if (!loadMore || loadMore.hidden) return;
    loadMore.disabled = false;
    loadMore.classList.remove('is-filter-pending');
  }

  function render(fadeOnlyTiles, waitForFilter) {
    var visible = visibleTiles();
    tiles.forEach(function (tile) {
      var match = tileMatchesFilters(tile);
      var index = visible.indexOf(tile);
      var pagedOut = match && index >= shown;
      tile.classList.toggle('tile-card--hidden', !match);
      tile.classList.toggle('tile-card--paged-out', pagedOut);
    });

    var activeSubfilterGroup = availableSubfilterGroupFor(filterValue);
    if (filterGroup) filterGroup.classList.toggle('is-subfilter-active', !!activeSubfilterGroup);
    if (filterBar) filterBar.classList.toggle('is-subfilter-active', !!activeSubfilterGroup);
    Array.prototype.forEach.call(subfilterGroups, function (group) {
      group.hidden = group !== activeSubfilterGroup;
    });
    subfilterButtons.forEach(function (btn) {
      var owner = btn.closest('[data-subfilters]');
      var active = owner === activeSubfilterGroup && btn.getAttribute('data-subfilter-value') === subfilterValue;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var item = btn.closest('.home-tiles__subfilter-item');
      var resetBtn = item && item.querySelector('[data-subfilter-reset]');
      if (resetBtn) resetBtn.hidden = !active;
    });

    buttons.forEach(function (btn) {
      var buttonValue = btn.getAttribute('data-filter-value');
      var active = !!filterValue && buttonValue === filterValue;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var item = btn.closest('.home-tiles__filter-item');
      if (item) item.classList.toggle('is-subfilter-owner', !!activeSubfilterGroup && active);
      var resetBtn = item && item.querySelector('[data-filter-reset]');
      if (!resetBtn) return;

      item.classList.toggle('has-active-reset', active);
      resetBtn.hidden = !active;
    });

    prepareLoadMore(shown < visible.length, waitForFilter);

    syncPackery(
      false,
      fadeOnlyTiles,
      waitForFilter ? revealLoadMoreAfterFilter : null
    );
    updateGridVisibility();
  }

  var gridHomeTop = null; /* Grid-viewport-top bei scrollY=0 (Layout-Konstante) */

  function getGridHomeTop() {
    if (gridHomeTop === null && grid) {
      gridHomeTop = grid.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    }
    return gridHomeTop;
  }

  function scrollToGridIfClipped() {
    if (!grid) return;
    var homeTop = getGridHomeTop();
    if (homeTop === null) return;

    var scrollY = window.scrollY || window.pageYOffset || 0;
    if (scrollY <= 0) return;

    var top = grid.getBoundingClientRect().top;
    /* Kacheln oben angeschnitten = Grid über den Ausgangszustand hinaus gescrollt */
    if (top >= homeTop) return;

    var isPhone = window.matchMedia(PHONE_MEDIA_QUERY).matches;
    var filterHeight = !isPhone && filterBar ? filterBar.offsetHeight : 0;
    var scrollTarget = Math.max(0, homeTop - filterHeight);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: scrollTarget, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function cancelFilterCue() {
    filterWasClicked = true;
    window.clearTimeout(filterCueStartTimer);
    filterCueTimers.forEach(window.clearTimeout);
    filterCueTimers = [];
    buttons.forEach(function (btn) {
      var label = btn.querySelector('.home-tiles__filter-label');
      if (label) label.classList.remove('is-auto-bouncing');
    });
  }

  function scheduleFilterCue() {
    if (
      !filterGroup ||
      isShopPage ||
      filterValue ||
      filterWasClicked ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) return;

    filterGroup.addEventListener('click', cancelFilterCue);
    filterCueStartTimer = window.setTimeout(function () {
      if (filterWasClicked) return;

      buttons.forEach(function (btn, index) {
        var label = btn.querySelector('.home-tiles__filter-label');
        if (!label) return;

        var timer = window.setTimeout(function () {
          if (filterWasClicked) return;
          label.classList.add('is-auto-bouncing');
          label.addEventListener('animationend', function () {
            label.classList.remove('is-auto-bouncing');
          }, { once: true });
        }, index * FILTER_CUE_STAGGER_MS);
        filterCueTimers.push(timer);
      });
    }, FILTER_CUE_DELAY_MS);
  }

  function applyFilter(value) {
    scrollToGridIfClipped();
    var nextValue = value || null;
    if (nextValue !== filterValue || !subfilterGroupFor(nextValue)) subfilterValue = null;
    filterValue = nextValue;
    shown = INITIAL_PAGE;
    render(null, true);
    syncUrlState();
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-filter-value');
      var isActive = btn.getAttribute('aria-pressed') === 'true';
      applyFilter(isActive ? null : value);
    });
  });

  resets.forEach(function (resetBtn) {
    resetBtn.addEventListener('click', function () {
      applyFilter(null);
    });
  });

  subfilterButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      scrollToGridIfClipped();
      var owner = btn.closest('[data-subfilters]');
      if (!owner || owner.getAttribute('data-subfilters') !== filterValue) return;
      var value = btn.getAttribute('data-subfilter-value');
      subfilterValue = subfilterValue === value ? null : value;
      shown = INITIAL_PAGE;
      render(null, true);
      syncUrlState();
    });
  });

  subfilterResets.forEach(function (resetBtn) {
    resetBtn.addEventListener('click', function () {
      scrollToGridIfClipped();
      subfilterValue = null;
      shown = INITIAL_PAGE;
      render(null, true);
      syncUrlState();
    });
  });

  if (loadMore) {
    loadMore.addEventListener('click', function () {
      var visible = visibleTiles();
      var nextShown = Math.min(shown + PAGE, visible.length);
      var remainder = visible.length - nextShown;

      if (remainder > 0 && remainder <= SMALL_REMAINDER) {
        nextShown = visible.length;
      }

      var newlyShown = visible.slice(shown, nextShown);
      shown = nextShown;
      render(newlyShown);
    });
  }

  tiles.forEach(function (tile) {
    enableImageFallback(tile);
    applyFormatFromMedia(tile);
  });
  render();
  initPackery();
  scheduleFilterCue();

  /* Den Filter genau dann ausblenden, wenn seine tatsächliche Unterkante
     die Unterkante der letzten sichtbaren Kachel erreicht. Dadurch gilt
     dieselbe Grenze mit und ohne eingeblendeten Produkt-Subfilter. */
  if (grid && document.body) {
    window.addEventListener('scroll', updateGridVisibility, { passive: true });
    window.addEventListener('resize', updateGridVisibility);
    updateGridVisibility();
  }
})();
